export interface OrdersCodesResponse {
  orders: OrderCodeItem[];
}

export interface OrderCodeItem {
  orderCode: string;
  orderId?: string | number;
}
